import { Navigate } from "react-router-dom";
import { hasPermission } from "../utils/permissions";

export default function PermissionRoute({
  permission,
  children
}) {

  if (!hasPermission(permission)) {
    return <Navigate to="/" />;
  }

  return children;
}